import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import MarkdownSnippet from '../Markdown-Snippet';

export const CaseStudyItem = ({content, coverImage, tags, title, url}) => (
  <div className="mt-12 first:mt-0 grid grid-cols-1 sm:grid-cols-12 sm:gap-12">
    <div className="mb-4 sm:mb-0 sm:col-span-4">
      <GatsbyImage image={coverImage.localFile.childImageSharp.gatsbyImageData} alt={coverImage.alternativeText} />
    </div>
    <div className="self-center flex flex-col sm:col-span-6">
      <Link to={url}>
        {tags && (
          <div>
            {tags.map(tag => <span className="text-orange font-semibold first:ml-0 mx-2 last:mr-0" key={tag}>{tag}</span>)}
          </div>
        )}
        <h4 className="text-md font-bold mb-4 sm:mb-8">{title}</h4>
        <div className="flex-1">
          <MarkdownSnippet content={content} className="prose line-clamp-5" />
        </div>
      </Link>
    </div>
  </div>
);

export default CaseStudyItem;
